"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderSuccess = exports.borderPrimary = exports.borderLightest = exports.borderLight = exports.borderError = exports.borderDarkest = exports.borderDark = void 0;
exports.borderDark = "1px solid #333333";
exports.borderDarkest = "1px solid #000000";
exports.borderError = "1px solid #fb6060";
exports.borderLight = "1px solid #f5f5f5";
exports.borderLightest = "1px solid #ffffff";
exports.borderPrimary = "1px solid #ececec";
exports.borderSuccess = "1px solid #85d69e";